import type { FormSchema } from "@/types/domain";

import { extractReferencedFieldNames, getFieldIdByName } from "./utils";

export type ExpressionDependencyConfig = {
  mode: "scoped" | "broad";
  dependencyIds: string[];
  usesApplicantContext: boolean;
};

export function classifyExpressionDependencies(
  code: string,
  entities: FormSchema["entities"],
): ExpressionDependencyConfig {
  const usesApplicantContext =
    /\bgetApplicantProfile\s*\(/.test(code) ||
    /\bgetApplication\s*\(/.test(code);
  const hasGetFormFieldCall = /getFormField\s*\(/.test(code);
  const allGetFormFieldCalls = code.match(/getFormField\s*\(/g)?.length ?? 0;
  const staticGetFormFieldCalls =
    code.match(/getFormField\s*\(\s*["'][a-zA-Z0-9_-]+["']\s*\)/g)?.length ?? 0;

  if (
    hasGetFormFieldCall &&
    (staticGetFormFieldCalls === 0 ||
      allGetFormFieldCalls !== staticGetFormFieldCalls)
  ) {
    return { mode: "broad", dependencyIds: [], usesApplicantContext };
  }

  const referencedNames = extractReferencedFieldNames(code);
  if (referencedNames.length === 0) {
    return { mode: "scoped", dependencyIds: [], usesApplicantContext };
  }

  const resolvedIds: string[] = [];
  for (const name of referencedNames) {
    const id = getFieldIdByName(entities, name);
    if (!id) {
      return { mode: "broad", dependencyIds: [], usesApplicantContext };
    }
    resolvedIds.push(id);
  }

  return {
    mode: "scoped",
    dependencyIds: Array.from(new Set(resolvedIds)),
    usesApplicantContext,
  };
}
